import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
	DataGridPremium,
	GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
	GridActionsCellItem,
	GridToolbar
} from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomPagination } from "../../../../../components/mui/grids/dataGridCustom/customPagination";
import { muiGridLocales } from "../../../../../helpers/muiGridLocales";
import { getRouteUrl } from "../../../../../helpers/routing/getRouteUrl";
import { useMuiGridServerSide } from "../../../../../hooks/muiGrid/useMuiGridServerSide";
import { USERS } from "../../../locales/namespaces";
import { ROUTE_PAGE_USERS_DETAILS, ROUTE_PAGE_USERS_EDIT } from "../../../routes/routes";

export function UserGridContainer({ role, language, dateFormat }) {
	const { t } = useTranslation(USERS);
	
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange
	} = useMuiGridServerSide({
		url: 'user/indexTable/data',
		initialPageSize: 50,
		otherDataParams: {
			role: role,
		},
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	
	const columns = useMemo(() => {
		return [
			// ...(editUser ? [
			// 	{
			// 		headerName: t('Actions'),
			// 		field: 'actions',
			// 		type: 'actions',
			// 		getActions: (params) => {
			// 			if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
			// 				return []
			// 			}
			// 			return [
			// 				<GridActionsCellItem
			// 					component={Link}
			// 					to={getRouteUrl(ROUTE_PAGE_USERS_EDIT, { id: params.id })}
			// 					icon={
			// 						<Tooltip title={t('Edit')}>
			// 							<IconButton>
			// 								<EditIcon/>
			// 							</IconButton>
			// 						</Tooltip>
			// 					}
			// 					color={'info'}
			// 					label={t('Edit')}>
			// 				</GridActionsCellItem>
			// 			]
			// 		}
			// 	}
			// ] : []),
			{
				headerName: t('Actions'),
				field: 'actions',
				type: 'actions',
				getActions: (params) => {
					if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
						return []
					}
					return [
						<GridActionsCellItem
							component={Link}
							to={getRouteUrl(ROUTE_PAGE_USERS_EDIT, { id: params.id, role: role })}
							icon={
								<Tooltip title={t('Edit')}>
									<IconButton>
										<EditIcon/>
									</IconButton>
								</Tooltip>
							}
							color={'info'}
							label={t('Edit')}>
						</GridActionsCellItem>
					]
				}
			},
			{
				field: 'LoginName',
				headerName: t('Name'),
				minWidth: 300,
				flex: 1,
				// renderCell: ({ row }) => (
				// 	<Link to={getRouteUrl(ROUTE_PAGE_USERS_DETAILS, {
				// 		id: row.id,
				// 		role: role,
				// 	})}>
				// 		{row.LoginName}
				// 	</Link>
				// )
			},
			{
				field: 'email',
				headerName: t('Email'),
				minWidth: 200, flex: 1,
			},
			...(Number(role) === 0
				? [{
					field: 'last_login',
					headerName: t('Last Login'),
					minWidth: 180,
					flex: 1,
					align:'center',
					valueFormatter: (value) => {
						return (value ? dayjs(value).format(dateFormat) : null)
					},
					valueGetter: (value) => {
						return value && new Date(value)
					}
				}]
				: []),
			
			{
				field: 'isActive',
				headerName: t('Active'),
				minWidth: 150, flex: 1,
				type: 'boolean',
				valueGetter: (value, row, column, apiRef) => value === '1'
			}
		]
	}, [t])
	
	return (
		<DataGridPremium
			columns={columns}
			initialState={{ density: "compact" }}
			rows={data}
			pagination
			paginationModel={{ page, pageSize }}
			paginationMode="server"
			onPaginationModelChange={onPaginationModelChange}
			rowCount={Number(total)}
			pageSizeOptions={[5, 10, 15, 20, 50, 100]}
			sortingMode="server"
			onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
			filterMode="server"
			onFilterModelChange={onFilterModelChange}
			loading={isLoading}
			localeText={muiGridLocales(language)}
			slots={{
				pagination: CustomPagination,
				toolbar: GridToolbar,
			}}
		/>
	);
}
